// Generated by ReScript, PLEASE EDIT WITH CARE


var instanceBlockCode = "instance";

var blockCodeDelimiter = "::";

var blockCodePrefix = instanceBlockCode + blockCodeDelimiter;

function make(blockId) {
  return blockCodePrefix + blockId;
}

function toString(blockCode) {
  return blockCode;
}

function fromString(x) {
  var parts = x.split(blockCodeDelimiter);
  var prefix = parts[0];
  var id = parts[1];
  if (prefix !== undefined && id !== undefined && !(id === "" || prefix !== instanceBlockCode)) {
    return blockCodePrefix + id;
  }
  
}

function getBlockId(customBlockCode) {
  return customBlockCode.split(blockCodePrefix)[1];
}

var Code = {
  blockCodePrefix: blockCodePrefix,
  make: make,
  toString: toString,
  fromString: fromString,
  getBlockId: getBlockId
};

export {
  Code ,
}
/* No side effect */
